export function equal(val, args) {
  return val === args[0];
}